<template lang="html">
    <div class="inner-content">
        <!-- <tl-select label="Select Month" labelText="month" :options="monthsData" v-model="formData.month" @change="(val)=>formData.month = val"
            name="month" :classname="errors.has('month')" v-validate="'required'" :errormsg="errors.first('month')"></tl-select> -->

        <div class="uploadClass margin-top-10">
            <tl-radio name="uploadMethod2" label="Manual" id="manualUpload" value="manualUpload" v-model="formData.uploadMethod"
            />

            <tl-radio name="uploadMethod1" label="Bulk Upload" id="bulkUpload" value="bulkUpload" v-model="formData.uploadMethod"
            />
        </div>

        <div v-if="formData.uploadMethod == 'manualUpload'" class="margin-top-3">
            <tl-search class="search-width" @change="filterData" :value="searchText" v-model="searchText" />

            <ul class="search-result" v-if="auto_suggestions && filterEmpData.length">
                <li v-for="(employee,index) in filterEmpData" :key="index" v-on:click="itemclicked(employee)">
                    <div class="threeColumnGrid">
                        <div class="sm-img">
                            <img src="@/assets/user.svg" />
                        </div>
                        <div class="empDetails">
                            <div class="empName">
                                <label>{{employee.name}}</label>
                            </div>
                            <div class="empcode">
                                <label>{{employee.code}}</label>
                            </div>
                            <div class="empcode">
                                <label>{{employee.email}}</label>
                            </div>
                        </div>
                        <div class="role">
                            <label class="development-text">{{employee.role}}</label>
                        </div>
                    </div>
                </li>
            </ul>
            <ul class="search-result" v-else-if="auto_suggestions && !filterEmpData.length">
                <li>No data Available </li>
            </ul>

            <div class="employee-card margin-top-3">
                <div>
                    <img src="@/assets/user.svg" alt="actionIcon">
                </div>
                <div class="card-details">
                    <label class="name">Roxie Schmidt</label>
                    <p>FBP Month: July</p>
                    <div class="margin-top-10">
                        <p class="finance-data">Total Eligibility : $25000</p>
                        <p class="finance-data">Total Claimed : $15000</p>
                        <p class="finance-data approved">Total Approved : $10000</p>
                    </div>
                </div>
            </div>

            <div class="margin-top-40">
                <btn text="Add New Claim" type="secondary" @click="addNewClaim" />
            </div>
        </div>
        <div v-else class="margin-top-3">
            <upload></upload>
            <div class="margin-top-40">
                <btn class="custom-btn" text="Submit" type="primary" @click="backToDashboard" />
            </div>
        </div>


        <bottom-action-container >
            <template slot="end">
                <btn-grp>
                    <btn text="Back To Dashboard" type="secondary" @click="backToDashboard" />
                </btn-grp>
            </template>
        </bottom-action-container>

    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "uploadFbpClaim",
  computed: {
    ...mapState({}),
    ...mapGetters({
      orgid: "onboard/organization/orgid"
    })
  },
  data() {
    return {
      filterEmpData: [],
      selectedSearchItems: [],
      searchText: "",
      auto_suggestions: false,
      formData: {
        uploadMethod: "manualUpload",
        month: ""
      },
      monthsData: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      employeeData: [
        {
          id: 1,
          code: "RC1234",
          name: "Roxi",
          department: "IT",
          email: "Roxi@gmail.com",
          noofDocs: 5,
          essstatus: "Active",
          imgSrc: require("@/assets/user.svg"),
          action: "",
          role: "Development"
        },
        {
          id: 2,
          code: "RC1234",
          name: "Roxi",
          department: "IT",
          email: "Roxi@gmail.com",
          noofDocs: 10,
          essstatus: "Active",
          imgSrc: require("@/assets/user.svg"),
          action: "",
          role: "Development"
        },
        {
          id: 3,
          code: "RC1234",
          name: "Roxi",
          department: "IT",
          email: "Roxi@gmail.com",
          noofDocs: 15,
          essstatus: "Active",
          imgSrc: require("@/assets/user.svg"),
          action: "",
          role: "Development"
        }
      ]
    };
  },
  mounted() {},

  methods: {
    ...mapActions({}),

    filterData(searchText) {
      if (searchText.length) {
        this.auto_suggestions = true;
        this.filterEmpData = this.searchData(searchText, this.employeeData);
      } else {
        this.auto_suggestions = false;
      }
    },
    searchData(key, array) {
      const final = [];
      for (let i = 0; i < array.length; i++) {
        let searchObj = array[i].name;
        if (
          searchObj != null &&
          searchObj.toLowerCase().search(key.toLowerCase()) !== -1
        ) {
          final.push(array[i]);
        }
      }
      return final;
    },

    itemclicked(emp) {
      //console.log("itemclicked:", emp);
      this.selectedSearchItems.push(emp);
      this.searchText = "";
      this.auto_suggestions = false;
    },

    addNewClaim() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/newfbpclaim`
      });

      //this.$router.push({ path: "/dashboard/payroll/utilities/newfbpclaim" });
    },

    backToDashboard() {}
  }
};
</script>

<style lang="scss" scoped>
.tl-select-dropdown {
  margin-bottom: 0px;
}

.uploadClass {
  display: flex;
}

.margin-top-3 {
  margin-top: 3%;
}

.margin-top-10 {
  margin-top: 10px;
}

.margin-top-40 {
  margin-top: 40px;
}

.margin-top-20 {
  margin-top: 20px;
}

.custom-btn {
  min-width: 150px;
  height: 45px;
  padding: 12px;
}

.search-width {
  max-width: 30%;
}

.search-container {
  width: 30%;
}

.align-filters {
  display: flex;
  margin: 0px 0 0 -10px;
  *:nth-child(1) {
    text-align: center;
  }
  button {
    border-radius: 100px;
    background-color: #b2f8f7;
  }
}

.filters {
  width: 125px;
  height: 28px;
  display: flex;
  justify-content: space-between;
  margin-left: 10px;
  *:nth-child(1) {
    margin-right: 10px;
    padding-left: 5px;
  }
  img {
    margin-top: 3px;
    margin-right: 10px;
    cursor: pointer;
  }
}

.search-result {
  position: absolute;
  width: 26.2%;
  background: #ffffff;
  max-height: 368px;
  border-radius: 4px;
  border: solid 1px #f7f7f7;
  overflow: auto;
  z-index: 1;
  li {
    padding: 15px;
    border-bottom: 0.5px solid #e3e3e3;
    margin-right: 0px !important;
    &:hover {
      background-color: #d6f2f2;
    }
  }
}

.empName label {
  font-size: 14px;
  font-weight: 600;
  color: #9c9c9c;
  margin-bottom: 4px;
}

.empcode label {
  font-size: 12px;
  font-weight: normal;
  color: #878787;
}

.filters {
  width: auto;
}

.search-bar {
  height: 35px;
}

.search-icon {
  top: 9px;
}

.employee-card {
  display: grid;
  grid-template-columns: 50px auto;

  grid-gap: 18px;
  width: 30%;
  height: 150px;
  opacity: 0.8;
  border-radius: 10px;
  border: solid 1px #cccfce;
  background-color: #ffffff;
  padding: 23px;
  img {
    width: 55px;
    height: 55px;
    opacity: 0.8;
    border-radius: 41px;
  }
  .card-details {
    .name {
      opacity: 0.8;
      font-family: Montserrat;
      font-size: 16px;
      font-weight: 500;
      color: #535353;
    }
    p {
      margin-bottom: 2px;
      color: #979797;
      font-size: 12px;
    }
    .finance-data {
      opacity: 0.8;
      font-family: Montserrat;
      font-size: 16px;
      font-weight: 500;
      font-style: normal;
      color: #535353;
    }
    .approved {
      color: #34c0be;
    }
  }
}

.sm-img {
  img {
    width: 50px;
  }
}

.development-text {
  font-family: Montserrat;
  font-size: 12px;
  font-weight: normal;
  color: #9c9c9c;
}

.role{
    padding: 18px;
}
</style>